/**
 * approval-document (품의서) orval 래퍼
 *
 * orval 생성 함수를 기존 SDK 패턴(approvalDocumentApi.xxx)으로 래핑한다.
 * 기존 코드에서 import 경로만 바꾸면 되도록 동일한 인터페이스를 제공한다.
 *
 * 전환 완료 후 기존 `packages/shared/api/nest/approval-document.api.ts`는 삭제한다.
 */
import { get } from "../endpoints/품의서/품의서";
// orval이 생성한 factory에서 API 함수들을 꺼낸다
const generated = get();
// ── 기존 SDK와 동일한 인터페이스 ──
async function getApprovalDocuments(params) {
    return generated.approvalDocumentControllerGetApprovalDocuments(params);
}
async function getApprovalDocument(id) {
    return generated.approvalDocumentControllerGetApprovalDocument(id);
}
async function getApprovalDocumentProcess(id) {
    return generated.approvalDocumentControllerGetProcess(id);
}
async function getProcessList(params) {
    return generated.approvalDocumentControllerGetProcessList(params);
}
async function createApprovalDocument(body) {
    return generated.approvalDocumentControllerPostApprovalDocument(body);
}
async function updateApprovalDocument(id, body) {
    return generated.approvalDocumentControllerPatchApprovalDocument(id, body);
}
async function submitApprovalDocument(id) {
    return generated.approvalDocumentControllerPatchSubmit(id);
}
async function cancelSubmission(id) {
    return generated.approvalDocumentControllerPatchCancelSubmission(id);
}
async function getProductsForInbound(id) {
    return generated.approvalDocumentControllerGetProductsForInbound(id);
}
async function deleteApprovalDocument(id) {
    return generated.approvalDocumentControllerDeleteApprovalDocument(id);
}
// ── SDK 객체 (기존 approvalDocumentApi와 동일 shape) ──
export const approvalDocumentApi = {
    getApprovalDocuments,
    getApprovalDocument,
    getApprovalDocumentProcess,
    getProcessList,
    getProductsForInbound,
    createApprovalDocument,
    updateApprovalDocument,
    submitApprovalDocument,
    cancelSubmission,
    deleteApprovalDocument,
};
